import { render } from "./addOrderRecord.vue?vue&type=template&id=4210ec66&scoped=true"
import script from "./addOrderRecord.vue?vue&type=script&lang=js"
export * from "./addOrderRecord.vue?vue&type=script&lang=js"

import "./addOrderRecord.vue?vue&type=style&index=0&id=4210ec66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4210ec66"]])

export default __exports__